(() => {
  const root = document.getElementById('mp-assistant');
  if (!root) return;
  const dialog = root.querySelector('dialog');
  if (typeof dialog.showModal !== 'function') return;
  const launcher = root.querySelector('[data-mpa-launch]');
  const back = root.querySelector('[data-mpa-back]');
  const title = root.querySelector('#mpa-title');
  const subtitle = root.querySelector('[data-mpa-subtitle]');
  const defaultTitle = title.textContent;
  const defaultSubtitle = subtitle.textContent;
  const loading = root.querySelector('[data-mpa-loading]');
  const frames = [...root.querySelectorAll('iframe')];
  const stack = ['home'];
  let currentTool = '', activeFrame = null, pendingOffer = null;
  const sendOffer = () => { if (pendingOffer && activeFrame?.dataset.mpaFrame === 'offer' && activeFrame.dataset.ready === 'true') { activeFrame.contentWindow.postMessage({type:'mp-assistant-offer-selection',items:pendingOffer},location.origin); pendingOffer=null; } };
  const isTool = screen => ['finder', 'compare', 'calculator', 'offer', 'registration'].includes(screen);
  const productCalculator=()=>document.querySelector('mp-product-savings:not([data-standalone="true"])');
  const sendCalculator=()=>{
    const calculator=productCalculator();
    if(calculator?.variantValid && calculator.dataset.mode==='system' && activeFrame?.dataset.mpaFrame==='calculator' && activeFrame.dataset.ready==='true')
      activeFrame.contentWindow.postMessage({type:'mp-assistant-calculator-state',snapshot:calculator.snapshot()},location.origin);
  };
  document.addEventListener('mp:savings-update',sendCalculator);
  const sendMode = () => activeFrame?.contentWindow?.postMessage({type:'mp-assistant-mode', mode:currentTool}, location.origin);
  async function loadFrame(frame, url) {
    frame.dataset.loading = 'true';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, {credentials:'same-origin', signal:controller.signal});
      if (!response.ok) throw new Error('Tool unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (!doc.body.classList.contains('mp-assistant-tool')) throw new Error('Tool template unavailable');
      // The payment-discount app belongs to the storefront shell; these tools never edit its cart.
      doc.querySelectorAll('script[src*="/scala-discounts-"][src$="/cartApi.js"]').forEach(script=>script.remove());
      const base = doc.createElement('base');
      base.href = url.href;
      doc.head.prepend(base);
      frame.srcdoc = '<!doctype html>' + doc.documentElement.outerHTML;
    } catch (error) {
      if (frame === activeFrame) loading.textContent = root.dataset.error;
    } finally {
      clearTimeout(timeout);
      frame.dataset.loading = 'false';
    }
  }
  function render(focus = true) {
    const screen = stack[stack.length - 1];
    const tool = isTool(screen);
    root.querySelectorAll('[data-mpa-screen]').forEach(el => el.hidden = el.dataset.mpaScreen !== (tool ? 'tool' : screen));
    back.hidden = stack.length === 1;
    dialog.dataset.wide = String(tool);
    title.textContent = tool || screen === 'chat' ? root.dataset[screen + 'Title'] : defaultTitle;
    dialog.dataset.screen = screen;
    subtitle.textContent = screen === 'business' ? root.querySelector('[data-mpa-screen="business"]').dataset.subtitle : screen === 'chat' ? root.dataset.chatSubtitle : defaultSubtitle;
    if (tool) {
      currentTool = screen;
      activeFrame = frames.find(frame => frame.dataset.mpaFrame === (['calculator','offer','registration'].includes(screen) ? screen : 'tools'));
      frames.forEach(frame => frame.hidden = frame !== activeFrame || frame.dataset.ready !== 'true');
      activeFrame.title = title.textContent;
      const url = new URL(root.dataset[screen+'Url'] || root.dataset.toolUrl, location.origin);
      url.searchParams.set('view', ['calculator','offer','registration'].includes(screen) ? 'mp-assistant-'+screen : 'mp-assistant-tools');
      if (window.Shopify?.theme?.role === 'unpublished') {url.searchParams.set('preview_theme_id', window.Shopify.theme.id);url.searchParams.set('_fd','0');url.searchParams.set('pb','0');}
      url.hash = screen;
      root.querySelector('[data-mpa-fallback]').href = url.href;
      loading.hidden = activeFrame.dataset.ready === 'true';
      if (!activeFrame.hasAttribute('src') && !activeFrame.hasAttribute('srcdoc') && activeFrame.dataset.loading !== 'true') loadFrame(activeFrame, url);
      else {sendMode();sendOffer();sendCalculator();}
    }
    root.querySelector('.mpa-content').scrollTop = 0;
    if (focus) title.focus({preventScroll:true});
  }
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-mpa-go]');
    if (button) { stack.push(button.dataset.mpaGo); render(); }
  });
  launcher.addEventListener('click', () => { dialog.showModal(); launcher.setAttribute('aria-expanded','true'); render(); });
  root.querySelector('[data-mpa-close]').addEventListener('click', () => dialog.close());
  back.addEventListener('click', () => { if (stack.length > 1) stack.pop(); render(); });
  dialog.addEventListener('close', () => { launcher.setAttribute('aria-expanded','false'); updateLauncherVisibility(); if (!launcher.hidden) launcher.focus({preventScroll:true}); });
  frames.forEach(frame => frame.addEventListener('load', () => {
    if (frame === activeFrame) {sendMode();sendOffer();sendCalculator();}
  }));
  window.addEventListener('message', event => {
    if (event.origin !== location.origin) return;
    const frame = frames.find(item => item.contentWindow === event.source);
    if (!frame) return;
    if(event.data?.type==='mp-assistant-calculator-ready') {sendCalculator();return;}
    if(event.data?.type==='mp-assistant-calculator-change' && frame.dataset.mpaFrame==='calculator') {
      const calculator=productCalculator();
      if(calculator && String(calculator.dataset.productId)===String(event.data.snapshot?.productId)) calculator.applySnapshot(event.data.snapshot);
      return;
    }
    if (event.data?.type === 'mp-assistant-inquiry' && Array.isArray(event.data.items) && event.data.items.length <= 10 && event.data.items.every(s=>/^[a-z0-9][a-z0-9-]*$/.test(s.h)&&Number.isInteger(s.q)&&s.q>0&&s.q<=99)) {pendingOffer=event.data.items;stack.push('offer');render();return;}
    if (event.data?.type === 'mp-assistant-ready') {frame.dataset.ready = 'true'; if (frame === activeFrame) {frame.hidden=false;loading.hidden = true; sendMode();sendOffer();sendCalculator();}}
    if (event.data?.type === 'mp-assistant-close' && dialog.open) dialog.close();
    if (event.data?.type === 'mp-assistant-tool' && ['finder','compare'].includes(event.data.mode)) {stack[stack.length-1] = event.data.mode; render(false);}
  });
  const mobileViewport = window.matchMedia('(max-width:640px), (max-width:960px) and (max-height:500px) and (pointer:coarse)');
  let visibilityFrame = 0;
  function updateLauncherVisibility() {
    visibilityFrame = 0;
    launcher.hidden = mobileViewport.matches && window.scrollY >= window.innerHeight * 2;
  }
  function scheduleLauncherVisibility() {
    if (!visibilityFrame) visibilityFrame = window.requestAnimationFrame(updateLauncherVisibility);
  }
  window.addEventListener('scroll', scheduleLauncherVisibility, {passive:true});
  window.addEventListener('resize', scheduleLauncherVisibility);
  window.addEventListener('pageshow', scheduleLauncherVisibility);
  mobileViewport.addEventListener('change', scheduleLauncherVisibility);
  updateLauncherVisibility();
})();

